export default function getFilterOptions(stage, role, isSupplierInvoice) {
    if (['admin', 'staff', 'sales'].includes(role)) {
        switch (stage) {
            case 'invoice':
                if (isSupplierInvoice) {
                    return [
                        { name: 'Supplier Invoices', value: 'supplier' },
                        { name: 'Supplier Archived Invoices', value: 'supplier_archive' }
                    ]
                }
                return [
                    { name: 'Customer Invoices', value: 'customer' },
                    { name: 'Customer Archived Invoices', value: 'customer_archive' },
                ]
            case 'order':
                return [
                    { name: 'Customer Orders', value: 'customer' },
                    { name: 'Supplier Orders', value: 'supplier' },
                    { name: 'Customer Archived Orders', value: 'customer_archive' },
                    { name: 'Supplier Archived Orders', value: 'supplier_archive' },
                    { name: 'Back Orders', value: 'back_order' },
                    { name: 'Reorder', value: 'reorder' }
                ];
            case 'rfq':
                return [
                    { name: 'Active RFQ', value: 'active_rfq' },
                    { name: 'Archived RFQ', value: 'archive_rfq' }
                ];
            case 'quote':
                return [
                    { name: 'Active Quote', value: 'active_quote' },
                    { name: 'Archived Quote', value: 'archive_quote' }
                ];
            case 'notifications':
                return [
                    { name: 'Customers', value: 'customers' },
                    { name: 'Suppliers', value: 'suppliers' }
                ]
            default:
                return [];
        }
    }
    if (role === 'customer') {
        switch (stage) {
            case 'order':
                return [
                    { name: 'Active Orders', value: 'customer' },
                    { name: 'Archived Orders', value: 'customer_archive' },
                ];
            case 'invoice':
                return [
                    { name: 'Active Invoices', value: 'customer' },
                    { name: 'Archived Invoices', value: 'customer_archive' },

                ];
            case 'container':
                return [
                    { name: 'Container Shipments', value: 'container_shipment_view' },
                    { name: 'Container Orders', value: 'container_orders_view' },

                ];
            default:
                return [];
        }
    }
    if (role === 'supplier') {
        switch (stage) {
            case 'in-production':
                return [
                    { name: 'Shipment View', value: 'inproduction_shipment_view' },
                    { name: 'Orders View', value: 'inproduction_orders_view' },
                ];
            case 'fulfilled':
                return [
                    { name: 'Orders View', value: 'shipped_orders_view' },
                    { name: 'Shipment View', value: 'shipped_shipment_view' },

                ];
            default:
                return [];
        }
    }
    return [];
}

/**
 * PGSS-5367 — a supplier's Shipped Orders / In Production view, read back from the URL.
 *
 * The list is fetched by the URL's `view_type` (set by OrderTypeFilter), but Orders.js used to reset the
 * dropdown to a fixed position whenever the URL carried a query string: options[1] on Shipped Orders, which is
 * Shipment View. So after a status filter, a page change or coming back from the Communication page, the rows
 * were still the Orders View's while the row actions were told "Shipment View" -- and Send Message (offered
 * on the Orders View only) disappeared.
 *
 * Returns the option the URL names, or null when it names none (keep the current one).
 */
const SUPPLIER_VIEW_BY_URL = {
    fulfilled: { fulfilled: 'shipped_orders_view', 'fulfilled-shipments': 'shipped_shipment_view' },
    'in-production': { 'inproduction-orders': 'inproduction_orders_view', 'in-production': 'inproduction_shipment_view' },
};

export function supplierViewOptionFromUrl(stage, options, viewType) {
    const value = SUPPLIER_VIEW_BY_URL[stage]?.[viewType];
    if (!value || !Array.isArray(options)) return null;
    return options.find((option) => option?.value === value) || null;
}
